import PropTypes from 'prop-types'
import ReceiptNo from './ReceiptNo'

/**
 * A softly tinted panel for secondary blocks and the landlord's side of a
 * record: carbon tint, ink text, the same edge, corners and padding as a
 * `Sheet`. Soft and mute ink both pass AA on the tint (6.8 and 4.9:1); the
 * status inks only just do, so a status on a Carbon takes `onCarbon`.
 * `ruled` is accepted for older callers and ignored.
 */
export default function Carbon({
  as: Tag = 'section',
  no,
  title,
  children,
  className = '',
  bodyClassName = '',
  // eslint-disable-next-line no-unused-vars
  ruled,
  ...rest
}) {
  return (
    <Tag
      className={`bg-carbon-tint text-ink border border-carbon/25 rounded-lg ${className}`}
      {...rest}
    >
      {(no !== undefined || title) && (
        <header className="flex items-baseline justify-between gap-4 px-6 sm:px-8 pt-pitch">
          {title ? (
            <h2 className="font-sans font-semibold text-xl leading-pitch text-ink text-balance">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {no !== undefined && <ReceiptNo n={no} tone="ink" />}
        </header>
      )}
      <div className={`px-6 sm:px-8 ${bodyClassName}`}>{children}</div>
    </Tag>
  )
}

Carbon.propTypes = {
  as: PropTypes.elementType,
  no: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  // No longer draws anything; kept so existing callers need no change.
  ruled: PropTypes.bool,
}
